// import '../../styles/admin/dashboard.css';

// function DashboardStats({ stats = {} }) {
//   const {
//     categories = 0,
//     produits = 0,
//     clients = 0,
//     vendeurs = 0,
//   } = stats;

//   return (
//     <div className="dashboard-stats">
//       <div className="stat-card"><h3>Catégories</h3><p>{categories}</p></div>
//       <div className="stat-card"><h3>Produits</h3><p>{produits}</p></div>
//       <div className="stat-card"><h3>Clients</h3><p>{clients}</p></div>
//       <div className="stat-card"><h3>Vendeurs</h3><p>{vendeurs}</p></div>
//     </div>
//   );
// }

// export default DashboardStats;

// src/components/admin/DashboardStats.jsx
import '../../styles/admin/dashboard.css';

function DashboardStats({ stats }) {
  return (
    <div className="dashboard-stats">
      <div className="stat-card">
        <h3>Catégories</h3>
        <p className="stat-value">{stats.categories}</p>
      </div>
      <div className="stat-card">
        <h3>Produits</h3>
        <p className="stat-value">{stats.produits}</p>
      </div>
      <div className="stat-card">
        <h3>Clients</h3>
        <p className="stat-value">{stats.clients}</p>
      </div>
      <div className="stat-card">
        <h3>Vendeurs</h3>
        <p className="stat-value">{stats.vendeurs}</p>
      </div>
    </div>
  );
}

export default DashboardStats;

